export default "__VITE_ASSET__666cf1cc__"